
export const DIV_NAVIGATION = "documentation--navigation";
export const DIV_CONTENT = "documentation--content";
